export const SELECT_STYLES = {
	control: (provided, state) => ({
		...provided,
		minHeight: '40px',
		borderRadius: 0,
		borderColor: state.isFocused ? '#000' : provided.borderColor,
		boxShadow: 'none',
		'&:hover': {
			borderColor: state.isFocused ? '#000' : provided.borderColor
		}
	}),
	placeholder: (provided) => ({
		...provided,
		color: '#98A2B3'
	})
};

export const getText = (value) => {
	if (typeof value === 'string' || typeof value === 'number') {
		return String(value);
	}

	if (value && typeof value === 'object') {
		return String(value?.label || value?.name || value?.title || value?.value || value?.id || '');
	}

	return '';
};

export const toSelectOptions = (items = []) => {
	const sourceItems = Array.isArray(items) ? items : items?.data || [];

	const mapped = sourceItems
		.map((item) => {
			if (typeof item === 'string') {
				return [item, { id: item, value: item, label: item }];
			}

			const id = getText(item?.id ?? item?.value);
			const value = getText(
				item?.value ?? item?.id ?? item?.primaryUserType ?? item?.name ?? item?.label
			);
			const label = getText(
				item?.label ?? item?.name ?? item?.primaryUserType ?? item?.value ?? item?.id
			);

			return value && label ? [`${value}::${label}`, { id, value, label }] : null;
		})
		.filter(Boolean);

	return Array.from(new Map(mapped).values());
};

export const toSelectedOptions = (items = [], options = []) => {
	const sourceItems = Array.isArray(items) ? items : items?.data || [];
	const normalizedOptions = Array.isArray(options) ? options : [];

	return sourceItems
		.map((item) => {
			const option = toSelectOptions([item])[0];
			if (!option) {
				return null;
			}

			return (
				normalizedOptions.find(
					(existingOption) =>
						existingOption?.id === option.id ||
						existingOption?.value === option.value ||
						existingOption?.label === option.label
				) || option
			);
		})
		.filter(Boolean);
};
